export const Hero =({handleLoginClick, scrollToFeatures})=> {
    return (
         <section className="landing-hero">
          <div className="landing-hero-content">
            <h1 className="landing-title">
              Portal Digital Integral para Proveedores
            </h1>
            <p className="landing-subtitle">
              Gestione sus facturas, consulte pagos en tiempo real y mantenga
              control total de su información financiera en una plataforma
              segura y eficiente
            </p>
            <div className="landing-cta">
              <button
                className="btn-cta btn-cta-primary"
                onClick={handleLoginClick}
              >
                <i className="bi bi-door-open"></i> Acceder al Portal
              </button>
              <button
                className="btn-cta btn-cta-secondary"
                onClick={scrollToFeatures}
              >
                <i className="bi bi-info-circle"></i> Conocer Más
              </button>
            </div>
          </div>
        </section>
    )}